/**
 * The backdrop behind the phone's navigation drawer.
 *
 * Its own file because `AppShell` is at its 400-line budget and this is a
 * closed subject: one element, one job, one reason to change.
 *
 * MOUNTED ONLY WHILE THE DRAWER IS OPEN, so there is never an invisible
 * click-catcher over the page. `z-40` puts it over the bottom nav (z-30), over
 * the top bar (z-[35], see its own note), and under the rail (z-50).
 *
 * `aria-hidden` and out of the tab order deliberately: the rail carries its own
 * labelled close button and the header toggle flips to "Close menu", so a third
 * identical announcement is noise. The scrim is a pointer affordance only —
 * the same pattern the command palette's scrim uses.
 */
export function MobileDrawerScrim({ onClose }: { onClose: () => void }): JSX.Element {
  return (
    <button
      type="button"
      className="fixed inset-0 z-40 bg-scrim/50 md:hidden"
      onClick={onClose}
      aria-hidden
      tabIndex={-1}
    />
  );
}
